<template>

    <div class="container">
        <nav class="navbar navbar-expand-lg navbar-dark py-lg-0 main-navbar col-12 mx-auto">
            <div class="navbar-brand mr-auto">
                <img src="/img/logo-white.svg">
            </div>
                    <ul class="navbar-nav ml-auto" style="display: contents">
                        <li class="nav-item">
                        <span class="nav-link font-aileron-bold" href="#">
                            {{ $page.props.auth.user.available_budget | toCurrency }}
                        </span>
                        </li>

                        <li class="nav-item">
                            <inertia-link class="nav-link font-aileron-semibold"
                                          :href="route('nl.employeedashboard.logout')">
                                <img src="/img/employee-dashboard/icon-logout.svg" class="mr-1 mr-md-0">
                                <span class="d-inline-block d-md-none">
                                {{ Lang.get('employeedashboard::shared.top_nav.logout') }}
                            </span>
                            </inertia-link>
                        </li>
                    </ul>
        </nav>

    </div>

</template>

<script>
export default {

    props: {
    },
    methods: {
    },
}
</script>
